export default "__VITE_ASSET__Bnc8GbHA__"